import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TextAreaFieldDialogComponent } from '../../components/core/text-area-field-dialog/text-area-field-dialog.component';

// Based on: https://darchuk.net/2019/01/11/angular-making-a-modal-service-by-extending-ngbmodal/
@Injectable({
  providedIn: 'root'
})
export class TextAreaFieldDialogService {
  lastErrorCloseResult: string;

  constructor(private modalService: NgbModal) { }

  public show = (title: string, fieldName: string, confirmationMessage: string, acceptCallback: (fieldValue: string) => void, rejectCallback?: () => void): void => {
    var ref = this.modalService.open(TextAreaFieldDialogComponent);
    var outputValue: string;

    // Get the OkDialog from the NgbModal object  
    let dialog: TextAreaFieldDialogComponent = ref.componentInstance as TextAreaFieldDialogComponent;

    // Set the dialog's properties
    dialog.title = title;
    dialog.message = confirmationMessage;
    dialog.fieldName = fieldName,
    dialog.accept = (fieldValue: string) => {
      outputValue = fieldValue;
      ref.close(1);
    };

    dialog.dismiss = () => {
      ref.dismiss(2);
    };

    ref.result.then((result) => {
      switch (result) {
        case 1:
          acceptCallback(outputValue);
          break;
        default:
          if (rejectCallback)
            rejectCallback();
      }
    }, (reason) => {
      if (rejectCallback)
        rejectCallback();
    })
  }
}
